import React from "react";
import { Modal, Button } from "react-bootstrap";
import { MdOutlineDeleteSweep, MdWarningAmber } from "react-icons/md";

const Dialog = ({
  isVisible,
  onConfirm,
  onCancel,
  DialogTitle = "Are you sure?",
  DialogMessage = "This action cannot be undone.",
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  type = "danger",
}) => {
  return (
    <Modal
      show={isVisible}
      onHide={() => onCancel && onCancel(false)}
      centered
      backdrop="static"
      className="custom-confirm-modal"
    >
      <Modal.Body className="p-4 text-center">
        <div
          className={`d-inline-flex align-items-center justify-content-center rounded-circle mb-3 p-3 ${
            type === "danger"
              ? "bg-danger-subtle text-danger"
              : "bg-warning-subtle text-warning"
          }`}
          style={{ width: "64px", height: "64px" }}
        >
          {type === "danger" ? (
            <MdOutlineDeleteSweep size={32} />
          ) : (
            <MdWarningAmber size={32} />
          )}
        </div>

        <h5 className="fw-bold mb-2 text-dark">{DialogTitle}</h5>
        {DialogMessage && (
          <p className="text-muted small mb-4 px-2">{DialogMessage}</p>
        )}

        <div className="d-flex align-items-center justify-content-center gap-3">
          <Button
            variant="light"
            className="px-4 py-2 fw-semibold rounded-3 text-secondary border shadow-sm"
            onClick={() => onCancel && onCancel(false)}
          >
            {cancelText}
          </Button>
          <Button
            variant={type === "danger" ? "danger" : "warning"}
            className="px-4 py-2 fw-semibold rounded-3 text-white shadow-sm border-0"
            style={
              type === "danger"
                ? { background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)" }
                : { background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" }
            }
            onClick={() => onConfirm && onConfirm(true)}
          >
            {confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Dialog;
